"use strict";
import jQuery from 'jquery';
import 'flickity/dist/flickity.min.css';
import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-fade';
import mixitup from 'mixitup';
import lozad from 'lozad';

import '../css/app.css';

(function($) {
    $(document).ready(function()
    {

		const observer = lozad();
		observer.observe();

		//toggle the menu
		document.getElementById('nav-toggle').onclick = function(){
			document.getElementById("nav-hamb").classList.toggle("hidden");
			document.getElementById("nav-close").classList.toggle("hidden");
			document.getElementById("nav-content").classList.toggle("hidden");
		}       

		//slider
		if($('.slider').length){
			var elem = document.querySelector('.slider');
			var flkty = new Flickity( elem, {
			  // options
			  pageDots: false,
			  prevNextButtons:false,
			  draggable: false,
			  autoPlay: 3000,
			  fade: true,
			  asNavFor :'.slider-info',
			});

			var elem2 = document.querySelector('.slider-info');
			var flkty2 = new Flickity( elem2, {
			  // options
			  pageDots:false,
			  contain: true,
			  prevNextButtons:false,
			  autoPlay: 3000,
			  wrapAround:true,
			});

			var elem3 = document.querySelector('.slider-cta');
			var flkty3 = new Flickity( elem3, {
			  // options
			  pageDots:false,
			  contain: true,
			  prevNextButtons:false,
			  autoPlay: 3000,
			  wrapAround:true,
			  asNavFor :'.slider-info',
			});

			var carouselStatus = document.querySelector('.carousel-status');

			function updateStatus() {
			  var slideNumber = flkty2.selectedIndex + 1;
			  carouselStatus.textContent = slideNumber + '/' + flkty2.slides.length;
			}
			updateStatus();

			flkty2.on( 'select', updateStatus );

			// previous
			$('.sl-prev').on( 'click', function() {
			  flkty2.next();

			});
			// next
			$('.sl-next').on( 'click', function() {
			  flkty2.previous();
			});

		}

		//slider testim hp
		if($('.slider-testim').length){
			var elemt = document.querySelector('.slider-testim');
			var flktyt = new Flickity( elemt, {
			  // options
			  pageDots: false,
			  autoPlay: true,
			  prevNextButtons:false,
			  cellAlign: 'left',
			});

			// previous
			$('.t-prev').on( 'click', function() {
			  flktyt.previous();

			});
			// next
			$('.t-next').on( 'click', function() {
			  flktyt.next();
			});


		}

		//faq filtering
		if($('.faqsall').length){
			var mixer = mixitup('.faqsall');
		}
		
		//videogallery
		if($('.videogallery').length){
			$('.videogallery .videothumb').each(function(){
				var yt_src = $(this).attr('data-url');
				var youtube_video_id = yt_src.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();

				if (youtube_video_id.length == 11) {
				    var video_thumbnail = $('<img src="//img.youtube.com/vi/'+youtube_video_id+'/0.jpg">');
				    $(this).prepend(video_thumbnail);
				    $(this).attr('data-id',youtube_video_id);
				}
			});

			$(".videothumb").on('click', function(e) {
			  e.preventDefault();
			  $("#video-popup-overlay,#video-popup-iframe-container,#video-popup-container,#video-popup-close").show();
			  
			  var srchref='',autoplay='',id=$(this).data('id');
			  var srchref="https://www.youtube.com/embed/";
			  
			  autoplay = '?autoplay=1';
			  
			  $("#video-popup-iframe").attr('src', srchref+id+autoplay);
			  
			  $("#video-popup-iframe").on('load', function() {
			    $("#video-popup-container").show();
			  });
			});

			$("#video-popup-close, #video-popup-overlay").on('click', function(e) {
			  $("#video-popup-iframe-container,#video-popup-container,#video-popup-close,#video-popup-overlay").hide();
			  $("#video-popup-iframe").attr('src', '');
			});


		}		

		inlineSVG();

    });

	function inlineSVG(){
			/*
			 * Replace all SVG images with inline SVG
			 */
			jQuery('img.svg').each(function(){
			    var $img = jQuery(this);
			    var imgID = $img.attr('id');
			    var imgClass = $img.attr('class');
			    var imgURL = $img.attr('src');

			    jQuery.get(imgURL, function(data) {
			        // Get the SVG tag, ignore the rest
			        var $svg = jQuery(data).find('svg');

			        // Add replaced image's ID to the new SVG
			        if(typeof imgID !== 'undefined') {
			            $svg = $svg.attr('id', imgID);
			        }
			        // Add replaced image's classes to the new SVG
			        if(typeof imgClass !== 'undefined') {
			            $svg = $svg.attr('class', imgClass+' replaced-svg');
			        }

			        // Remove any invalid XML tags as per http://validator.w3.org
			        $svg = $svg.removeAttr('xmlns:a');

			        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
			        if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
			            $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
			        }

			        // Replace image with new SVG
			        $img.replaceWith($svg);

			    }, 'xml');

			});

	}


})(jQuery);